import { memo, useCallback, useEffect, useState } from 'react'
import { InputText } from 'ui_kit_qmd'
import { useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import './EditEmergencyInfo.scss'
import {
  EMERGENCY_CONTACT_TEXT,
  FIRST_NAME_TEXT,
  LAST_NAME_TEXT,
  RELATIONSHIP_TO_PATIENT_TEXT,
  INTAKE_FORM_TYPE_PHONE_NUMBER_TEXT,
} from '../../../../../../utils/constants'
import { EditCardAccountInfo } from '../../../edit-card-account-info/EditCardAccountInfo'
import { PhoneInput } from '../../../../../../components/phone-input/PhoneInput'
import { setEmergencyInfoState } from '../../reducers/EmergencyInfoReducer'
import { errorCodes, getUserFriendlyErrorMessage } from '../../../../../../utils/errormessages'
import { validatePhoneNumber } from '../../../../../../store/charts/ChartsThunk'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const getPhoneNumberValue = (phoneNumberData) => {
  if (phoneNumberData) {
    return `${phoneNumberData.Number.replace(phoneNumberData.Prefix, '')}`
  }
  return ''
}

const mainInputContainerStyle = {
  width: '100%',
  marginBottom: 44,
}

export const EditEmergencyInfoBlock = memo(
  ({
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    stateInfo,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    dispatchInfo,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setIsPhoneValidationInProgress,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isSaveClickedBeforePhoneValidation,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isInitialEmergencyNumber,
  }) => {
    const {
      firstName,
      lastName,
      relationship,
      phoneCountry,
      firstNameLocalError,
      phoneNumber,
      phoneCountryCode,
      isPhoneCorrect,
      isOldNumberCorrect,
      lastNameLocalError,
      relationshipLocalError,
      phoneLocalError,
      isResetEmergencyContact,
      isPhoneValidation,
      isPhoneChanged,
      forcePhoneLocalError,
    } = stateInfo

    const { search } = useLocation()
    const params = new URLSearchParams(search)
    const id = params.get('id')

    const dispatch = useDispatch()

    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const phoneNumberValidationLoading = useSelector((state) => state.chartsReducer.loading)
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const patientInfo = useSelector((state) => state.chartsReducer.patientInfo)

    const currentPatientInfo = patientInfo?.[id]

    const [isPhoneValidationStarted, setIsPhoneValidationStarted] = useState(false)
    const [isShowPhoneGreenMark, setIsShowPhoneGreenMark] = useState(isPhoneCorrect)

    useEffect(() => {
      if (!firstName?.trim() && !lastName?.trim() && !relationship?.trim() && !phoneNumber?.trim()) {
        dispatchInfo(
          setEmergencyInfoState({
            isResetEmergencyContact: true,
            phoneLocalError: '',
            forcePhoneLocalError: '',
          }),
        )
      } else {
        dispatchInfo(
          setEmergencyInfoState({
            isResetEmergencyContact: false,
          }),
        )
      }
    }, [firstName, lastName, relationship, phoneNumber])

    useEffect(() => {
      if (isResetEmergencyContact) {
        dispatchInfo(
          setEmergencyInfoState({
            firstNameLocalError: '',
            lastNameLocalError: '',
            relationshipLocalError: '',
            phoneLocalError: '',
          }),
        )
      }
    }, [isResetEmergencyContact])

    useEffect(() => {
      if (phoneLocalError === getUserFriendlyErrorMessage(errorCodes.PHONE_NUMBER_CONNOT_MATCH_YOUR_OWN)) {
        dispatchInfo(
          setEmergencyInfoState({
            forcePhoneLocalError: phoneLocalError,
          }),
        )
      } else {
        setIsShowPhoneGreenMark(isPhoneCorrect)
      }
    }, [isPhoneCorrect, phoneLocalError])

    const checkEmergencyNumberAction = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (newPhoneCountryCode, newPhoneCountry) => {
        setIsPhoneValidationInProgress(true)
        dispatchInfo(
          setEmergencyInfoState({
            isPhoneValidation: true,
          }),
        )
        dispatch(
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          validatePhoneNumber(
            {
              Number: `+${newPhoneCountryCode || phoneCountryCode}${phoneNumber}`,
              Prefix: `+${newPhoneCountryCode || phoneCountryCode}`,
              CountryCode: newPhoneCountry?.toUpperCase() || phoneCountry.toUpperCase(),
            },
            id,
          ),
        )
      },
      [setIsPhoneValidationInProgress, dispatchInfo, dispatch, phoneCountryCode, phoneNumber, phoneCountry],
    )

    useEffect(() => {
      if (isSaveClickedBeforePhoneValidation && isPhoneChanged && !isPhoneValidationStarted) {
        setIsPhoneValidationStarted(false)
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        checkEmergencyNumberAction()
      }
    }, [isSaveClickedBeforePhoneValidation])

    const onChangeEmergencyFirstName = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (value) => {
        dispatchInfo(
          setEmergencyInfoState({
            firstName: value,
            firstNameLocalError: '',
          }),
        )
      },
      [dispatchInfo],
    )

    const onChangeEmergencyLastName = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (value) => {
        dispatchInfo(
          setEmergencyInfoState({
            lastName: value,
            lastNameLocalError: '',
          }),
        )
      },
      [dispatchInfo],
    )

    const onChangeEmergencyRelationship = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (value) => {
        dispatchInfo(
          setEmergencyInfoState({
            relationship: value,
            relationshipLocalError: '',
          }),
        )
      },
      [dispatchInfo],
    )

    const onChangeEmergencyPhoneCountry = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (code, country) => {
        dispatchInfo(
          setEmergencyInfoState({
            phoneCountry: country.countryCode,
            phoneCountryCode: code,
            forcePhoneLocalError: '',
          }),
        )
        if (phoneNumber) {
          checkEmergencyNumberAction(code, country.countryCode)
        }
      },
      [checkEmergencyNumberAction, dispatchInfo, phoneNumber],
    )

    const onChangeEmergencyPhoneNumber = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (value) => {
        if (!isNaN(value) && value[value.length - 1] !== '.') {
          if (value === getPhoneNumberValue(currentPatientInfo?.EmergencyContact?.PhoneNumber)) {
            setIsShowPhoneGreenMark(true)
            dispatchInfo(
              setEmergencyInfoState({
                isPhoneChanged: false,
              }),
            )
          } else {
            setIsShowPhoneGreenMark(false)
            dispatchInfo(
              setEmergencyInfoState({
                isPhoneChanged: true,
              }),
            )
          }

          dispatchInfo(
            setEmergencyInfoState({
              phoneNumber: value,
              phoneLocalError: '',
              forcePhoneLocalError: '',
            }),
          )
        }
      },
      [currentPatientInfo?.EmergencyContact?.PhoneNumber, dispatchInfo],
    )

    const onSetPhoneCountryCode = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (value) => {
        dispatchInfo(
          setEmergencyInfoState({
            phoneCountryCode: value,
          }),
        )
      },
      [dispatchInfo],
    )

    const onChangeIsPhoneCorrect = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (value) => {
        dispatchInfo(
          setEmergencyInfoState({
            isPhoneCorrect: value,
          }),
        )
      },
      [dispatchInfo],
    )

    const onSetPhoneError = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (value) => {
        dispatchInfo(
          setEmergencyInfoState({
            phoneLocalError: !isResetEmergencyContact ? value : '',
          }),
        )
      },
      [dispatchInfo, isResetEmergencyContact],
    )

    return (
      <EditCardAccountInfo className='edit-emergency-info-card' title={EMERGENCY_CONTACT_TEXT}>
        <InputText
          maxLength={50}
          containerStyle={mainInputContainerStyle}
          label={FIRST_NAME_TEXT}
          setValue={onChangeEmergencyFirstName}
          isError={firstNameLocalError}
          localError={firstNameLocalError}
          view='visitType'
          value={firstName}
          isDisableAutocomplete
        />
        <InputText
          maxLength={50}
          containerStyle={mainInputContainerStyle}
          label={LAST_NAME_TEXT}
          setValue={onChangeEmergencyLastName}
          isError={lastNameLocalError}
          localError={lastNameLocalError}
          view='visitType'
          value={lastName}
          isDisableAutocomplete
        />
        <InputText
          containerStyle={mainInputContainerStyle}
          label={RELATIONSHIP_TO_PATIENT_TEXT}
          setValue={onChangeEmergencyRelationship}
          isError={relationshipLocalError}
          localError={relationshipLocalError}
          view='visitType'
          value={relationship}
          isDisableAutocomplete
        />
        <PhoneInput
          // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
          id='edit-account-info-emergency-contact-phone'
          className='edit-account-info-emergency-contact-phone'
          inputLabel={INTAKE_FORM_TYPE_PHONE_NUMBER_TEXT}
          setCountryCode={onSetPhoneCountryCode}
          phoneCountry={phoneCountry}
          phoneNumber={phoneNumber}
          phoneCountryCode={phoneCountryCode}
          onChangeCountry={onChangeEmergencyPhoneCountry}
          onChangeNumber={onChangeEmergencyPhoneNumber}
          checkPhone={checkEmergencyNumberAction}
          isPhoneCorrect={isShowPhoneGreenMark}
          isOldNumberCorrect={isOldNumberCorrect}
          setIsPhoneCorrect={onChangeIsPhoneCorrect}
          setPhoneError={onSetPhoneError}
          error={phoneLocalError || forcePhoneLocalError}
          loading={phoneNumberValidationLoading}
          setIsPhoneValidationStarted={setIsPhoneValidationStarted}
          isPhoneValidationStarted={isPhoneValidationStarted}
          isPhoneValidation={isPhoneValidation}
          isResetEmergencyContact={isResetEmergencyContact}
          isInitialEmergencyNumber={isInitialEmergencyNumber}
        />
      </EditCardAccountInfo>
    )
  },
)
